import { Container } from '@bit/ui-common.ui-components/ss-components';
import * as DodWelcomeServices from 'services/dod/dodWelcomeServices';
import * as DodPersonalInformationServices from 'services/dod/dodPersonalInformationServices';
import * as DodOfficeAddressServices from 'services/dod/dodOfficeAddressServices';
import * as DodCredentialsServices from 'services/dod/dodCredentialsServices';
import * as DodSecurityServices from 'services/dod/dodSecurityServices';
import * as DodAuthorizationServices from 'services/dod/dodAuthorizationServices';
import * as DodReviewServices from 'services/dod/dodReviewServices';
import * as DodUnboundServices from 'services/dod/dodUnboundServices';
import * as DodDataServices from '../redux/services/dod/dodDataServices';
import * as updatePasswordServices from 'services/updatePasswordService';
import * as passwordResetServices from '../redux/services/passwordResetServices';
import * as StatusService from 'services/statusService';
import DodRegistrationLayout from 'components/layouts/DodRegistrationLayout';
import { captcha, help } from '@bit/ui-common.ui-components/ss-common-data';
import { ssFormServices } from '@bit/ui-common.ui-components/ss-utils';
import LoginDisabled from './LoginDisabled';

export default Container({
    state: ({ dod, registrationForm, helpData, captcha, passwordReset, passwordUpdate, commonData: { geoData, lookupData, textData }, status}) => ({
        dod,
        captcha,
        registrationForm,
        lookupData,
        textData,
        passwordReset,
        passwordUpdate,
        help: helpData,
        geo: geoData,
        loginStatus: status

    }),
    services: [
        DodPersonalInformationServices,
        DodAuthorizationServices,
        DodOfficeAddressServices,
        DodCredentialsServices,
        DodSecurityServices,
        DodWelcomeServices,
        DodReviewServices,
        ssFormServices,
        help.helpServices,
        captcha.captchaServices,
        DodDataServices,
        updatePasswordServices,
        passwordResetServices,
        StatusService
    ]
},
class DodRegistration extends DodRegistrationLayout {
    constructor(props) {
        super(props);
        // Adds all non-bound services to the list of available services.
        let { services } = this.props;
        services = Object.assign(services, DodUnboundServices);
        services.fetchLoginStatus();
    }

    componentDidMount() {
        if(super.componentDidMount) super.componentDidMount();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(super.componentDidUpdate) super.componentDidUpdate(prevProps, prevState, snapshot)
    }

    getSnapshotBeforeUpdate(prevProps, prevState) {
        if(super.getSnapshotBeforeUpdate) return super.getSnapshotBeforeUpdate(prevProps, prevState);
        else return null;
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if(super.getDerivedStateFromProps) return super.getDerivedStateFromProps(nextProps, prevState);
        else return null;
    }

    render() { 
        const {loginStatus} = this.props;
        if (loginStatus.nonPivLogin != 'N') {

            return (<div>{super.render() || []}</div>);
        }else {
            return (<LoginDisabled  />);
        }

}});
